export default function () {
    var linkList = document.querySelectorAll('a');

    if (linkList.lenght !== 0) {
        for (var i = 1; i < linkList.length; i++) {
            var parent = linkList[i].parentElement;
            if (parent.innerHTML.indexOf('[[') !== -1 && parent.innerHTML.indexOf(']]') !== -1) {
                parent.innerHTML = parent.innerHTML.replace('[[', '');
                parent.innerHTML = parent.innerHTML.replace(']]', '');
                parent.firstChild.classList.add('btn', 'btn-primary');
            }
        }
    }
}
